module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar buttonContext = (config || {}).entityContext;\n%>\n<div>\n<section class=\"top\">\n<section class=\"left\">\n<%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'cancel', symbolOnly: false } }); %>\n<%\nif(model.parentEntityID && config.entityIsDeletable !== false){\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'delete', context: buttonContext, symbolOnly: false } }); %><%\n}\n%>\n</section>\n<section class=\"right\">\n<%\nif(model.parentEntityID && config.showCooperationNavButton !== false){\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: buttonContext, mode: 'navToCooperations', symbolOnly: false } }); %><%\n}\nif(model.parentEntityID && config.showTripNavButton !== false){\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: buttonContext, mode: 'navToTrips', symbolOnly: false } }); %><%\n}\nif(model.parentEntityID && config.showDetailsNavButton !== false){\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: buttonContext, mode: 'details', symbolOnly: false } }); %><%\n}\nif(model.parentEntityID && config.showRefreshNavButton !== false){\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'refresh', context: buttonContext, mode: 'single', symbolOnly: false } }); %><%\n}\n%>\n<%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'submit', context: buttonContext, symbolOnly: false } }); %>\n</section>\n</section>\n<section class=\"content\">\n<%- helpers.renderSection('main') %>\n</section>\n</div>"
  , __filename = "components/templates/artCrm/entity/recordController.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var buttonContext = (config || {}).entityContext;

    ; __line = 3
    ; __append("\n<div>\n<section class=\"top\">\n<section class=\"left\">\n")
    ; __line = 7
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'cancel', symbolOnly: false } }) )
    ; __append("\n")
    ; __line = 8
    ; 
if(model.parentEntityID && config.entityIsDeletable !== false){

    ; __line = 10
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'delete', context: buttonContext, symbolOnly: false } }) )
    ; 
}

    ; __line = 12
    ; __append("\n</section>\n<section class=\"right\">\n")
    ; __line = 15
    ; 
if(model.parentEntityID && config.showCooperationNavButton !== false){

    ; __line = 17
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: buttonContext, mode: 'navToCooperations', symbolOnly: false } }) )
    ; 
}
if(model.parentEntityID && config.showTripNavButton !== false){

    ; __line = 20
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: buttonContext, mode: 'navToTrips', symbolOnly: false } }) )
    ; 
}
if(model.parentEntityID && config.showDetailsNavButton !== false){

    ; __line = 23
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: buttonContext, mode: 'details', symbolOnly: false } }) )
    ; 
}
if(model.parentEntityID && config.showRefreshNavButton !== false){

    ; __line = 26
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'refresh', context: buttonContext, mode: 'single', symbolOnly: false } }) )
    ; 
}

    ; __line = 28
    ; __append("\n")
    ; __line = 29
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'submit', context: buttonContext, symbolOnly: false } }) )
    ; __append("\n</section>\n</section>\n<section class=\"content\">\n")
    ; __line = 33
    ; __append( helpers.renderSection('main') )
    ; __append("\n</section>\n</div>")
    ; __line = 35
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/artCrm/entity/recordController.ejs

}